module.exports = __webpack_public_path__ + "static/img/2.b379b9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newTwo/2.png
// module id = JThx
// module chunks = 0